import { isEnglish } from './i18n'

/* Latin digits in Arabic too, as the rest of the panel prints figures. Arabic spells the
   unit out — its short form (`م.ب`) is not one readers recognise. */
const unit = (name) =>
  new Intl.NumberFormat(isEnglish ? 'en-GB' : 'ar-u-nu-latn', {
    style: 'unit',
    unit: name,
    unitDisplay: isEnglish ? 'short' : 'long',
    maximumFractionDigits: 1,
  })

const KILOBYTES = unit('kilobyte')
const MEGABYTES = unit('megabyte')

/**
 * A file's size for a reader: `35 kB`, `2.4 MB` — in the panel's language.
 *
 * Kilobytes under one megabyte, so a short document does not read as `0.1 MB`.
 *
 * @param {number|null|undefined} bytes
 * @returns {string} empty when the size is unknown
 */
export function formatFileSize(bytes) {
  if (!bytes || bytes < 0) return ''
  const megabytes = bytes / (1024 * 1024)
  return megabytes < 1
    ? KILOBYTES.format(Math.max(Math.round(bytes / 1024), 1))
    : MEGABYTES.format(megabytes)
}
